export const COUNTDOWN_MINUTES = 15; // min
export const THROTTLE_TIME = 60000; // ms
export const THROTTLE_INTERVAL = 10000; // ms

export default {
    COUNTDOWN_MINUTES,
    THROTTLE_TIME,
    THROTTLE_INTERVAL,
    showCountdownTimer: false
};
